export enum ClienteEnum {
    KEPLER = 'keplerweber',
}
